import BSidebar from './BSidebar';
import BHeader from './BHeader';
import { HeaderProvider } from '../context/HeaderContext';

const Body = ({ children }) => {
  return (
    <HeaderProvider>
      <div className={`font-poppins flex h-[100dvh] w-full flex-col bg-slate-50 md:flex-row`}>
        <div className={'hidden md:block'}>
          <BSidebar />
        </div>
        <main className="w-full overflow-auto bg-gray-50 pb-8">
          <BHeader />
          <div className={'w-full px-6'}>{children}</div>
        </main>
      </div>
    </HeaderProvider>
  );
};

export default Body;
